<h3-shape-list-item
  *ngFor="let shapeItem of shapeItems"
  [shape]="shapeItem"
  matRipple
></h3-shape-list-item>
